import React, { useMemo, useState } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import styles from './EditPaymentDetails.module.scss';
import { FeatureFlag } from 'controllers/_exports';
import EditPaymentDetails from './EditPaymentDetails';

const EditPaymentDetailsModal = ({ cardInfo = {}, isDefault = false}) => {
  const [showModal, setShowModal] = useState(false);

  const show = useMemo(() => FeatureFlag.enabled('EDIT_SUBSCRIPTION'), []);

  if (!show) return null;

  return (
    <>
      <button variant="outlined" onClick={() => setShowModal(true)} className={styles.editButton}>
        Edit card details
      </button>
      <Dialog open={showModal} onClose={() => setShowModal(false)}>
        <DialogContent className={styles.CancelDialog}>
          <EditPaymentDetails setShowModal={setShowModal} cardInfo={cardInfo} isDefault={isDefault}/>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EditPaymentDetailsModal;
